







import { Component, Vue } from "vue-property-decorator";
import carouselCom from "../Index/carouselCom.vue";
import gameCom from "./gameCom.vue";
@Component({
  components: { carouselCom, gameCom },
})
export default class Home extends Vue {
  public value2 = 0;
  // public mounted() {}
}
